import React, {useEffect, useState} from 'react';
import {View} from 'react-native';

import DirectionsCarIcon from '~/images/md-icons/directions_car/materialicons/24px.svg';

const CarPersona = ({brand, size = 40}) => {
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const retrieve = async () => {
      const image_url = `https://bahnkick.blob.core.windows.net/company-logos/${brand}.svg`;
      setImage(image_url);
      setLoading(true);
    };

    retrieve();
  }, [brand]);

  const height = size;
  const width = size;

  return (
    <View
      style={{
        overflow: 'hidden',
        width,
        height,
        visibility: loading ? 'hidden' : 'visible',
      }}>
      {image ? (
        <img
          src={image}
          style={{width, height}}
          alt={brand}
          onLoad={() => {
            setLoading(false);
          }}
          onError={() => {
            setImage(null);
            setLoading(false);
          }}
        />
      ) : (
        <DirectionsCarIcon fill="#4A4A49" style={{width, height}} />
      )}
    </View>
  );
};

export default CarPersona;
